import { useEffect, useState } from "react";

import "./header.css";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { AiOutlineMenu } from "react-icons/ai";

import JHF from "../../imgs/jhf1.jpeg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Permissions } from "../../hooks/Permission/permission";

export default function Header(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const [isNavTreeviewVisible, setNavTreeviewVisible] = useState(false);
  const [isServicosOpen, setServicosOpen] = useState(false);
  const [isRelatoriosOpen, setRelatoriosOpen] = useState(false);
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    setTitle(props.title);
    if (location && location.state && location.state.username) {
      setName(location.state.username);
    }
  }, [location]);

  const handleLogout = () => {
    // Remover o token do LocalStorage
    localStorage.removeItem("token");
    // Redirecionar para a página de login
    navigate("/login");
  };

  const toggleNavTreeview = () => {
    setNavTreeviewVisible(!isNavTreeviewVisible);
  };
  const toggleServicos = () => {
    setServicosOpen(!isServicosOpen);
  };

  const toggleRelatorios = () => {
    setRelatoriosOpen(!isRelatoriosOpen);
  };

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <AiOutlineMenu />
            </a>
          </li>
          <li className="nav-item d-flex h-25">
            <Link to={`/home`} className="nav-link">
              {title}
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item h-25 ">
            <button
              className="d-flex justify-content-center btn btn-white border border-dark mr-4"
              onClick={handleLogout}
            >
              <FontAwesomeIcon
                icon={faPowerOff}
                className="pr-2 text-dark d-flex mt-1"
              />
              <a>Sair</a>
            </button>
          </li>
        </ul>
      </nav>

      <aside className="main-sidebar sidebar-light-primary elevation-4">
        <a className="brand-link d-flex justify-content-center">
          <img src={JHF} className="brand-image img-fluid"></img>
        </a>
        <div className="sidebar">
          <div className="user-panel mt-5 mb-5 d-flex custom-userbox">
            <div className="info">
              <a className="d-block">{localStorage.getItem("name")}</a>
              <small className="d-block">{`${localStorage.getItem(
                "idUnidade"
              )} - ${localStorage.getItem("nomeUnidade")}`}</small>
            </div>
          </div>

          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link to={`/home`} className="nav-link">
                  <i class="nav-icon fas fa-regular fa-house-user"></i>
                  <p style={{ alignItems: "center" }}>Home</p>
                </Link>
              </li>
              <nav className="mt-2">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li
                    className={`nav-item has-treeview ${
                      isNavTreeviewVisible ? "menu-open" : ""
                    }`}
                  >
                    <a
                      href="#"
                      className="nav-link"
                      onClick={toggleNavTreeview}
                    >
                      <i class="nav-icon far fa-plus-square"></i>
                      <p>
                        Cadastros
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </a>
                    <ul
                      className={`nav nav-treeview ${
                        isNavTreeviewVisible ? "show" : ""
                      }`}
                    >
                      <li className="nav-item">
                        <Permissions
                          requiredPermissions={[
                            {entidade: "Aplicacao", actions: ['view']}
                          ]}
                        >
                          <Link to={`/aplicacoes`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Aplicações</p>
                          </Link>
                        </Permissions>
                      </li>

                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "User", actions: ['view']}
                        ]}
                        >
                          <Link to={`/users`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Controle de Acesso</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "Empresa", actions: ['view']}
                        ]}
                        >
                          <Link to={`/empresas`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Empresas</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "GrupoMaterial", actions: ['view']}
                        ]}
                        >
                          <Link to={`/grupos-material`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Grupos de Material</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "Material", actions: ['view']}
                        ]}
                        >
                          <Link to={`/materiais`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Material</p>
                        </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "Pessoa", actions: ['view']}
                        ]}
                        >
                          <Link to={`/pessoas`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Pessoas</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "Servicos", actions: ['view']}
                        ]}
                        >
                          <Link to={`/servicos`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Serviços</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "SetoresExecutantes", actions: ['view']}
                        ]}
                        >
                          <Link to={`/setores-executantes`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Setores Executantes</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "TiposAplicacao", actions: ['view']}
                        ]}
                        >
                          <Link to={`/tipos-aplicacao`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Tipos de Aplicação</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "TipoManutencao", actions: ['view']}
                        ]}
                        >
                          <Link to={`/tipos-manutencao`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Tipos de Manutenção</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "Unidade", actions: ['view']}
                        ]}
                        >
                          <Link to={`/unidades`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Unidades</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "UnidadeMedida", actions: ['view']}
                        ]}
                        >
                          <Link to={`/unidades-medida`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Unidades de Medida</p>
                          </Link>
                        </Permissions>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
              <nav className="mt-2">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li
                    className={`nav-item has-treeview ${
                      isServicosOpen ? "menu-open" : ""
                    }`}
                  >
                    <a href="#" className="nav-link" onClick={toggleServicos}>
                      <i class="nav-icon fa-solid fa-wrench"></i>
                      <p>
                        Serviços
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </a>
                    <ul
                      className={`nav nav-treeview ${
                        isServicosOpen ? "show" : ""
                      }`}
                    >
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "AplicacaoPlanoManutencao", actions: ['view']}
                        ]}
                        >
                          <Link to={`/gerenciamento-planos`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Gerenciamento de planos de manutenção</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "OrdensServico", actions: ['view']}
                        ]}
                        >
                          <Link to={`/ordens-servico`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Ordens de Serviço</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "PlanosManutencao", actions: ['view']}
                        ]}
                        >
                          <Link to={`/planos-manutencao`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Planos de Manutenção</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "SolicitacaoServico", actions: ['view']}
                        ]}
                        >
                          <Link to={`/solicitacoes-servico`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Solicitações de Serviço</p>
                          </Link>
                        </Permissions>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
              <nav className="mt-2">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li
                    className={`nav-item has-treeview ${
                      isRelatoriosOpen ? "menu-open" : ""
                    }`}
                  >
                    <a href="#" className="nav-link" onClick={toggleRelatorios}>
                      <i class="nav-icon fa-solid fa-chart-pie"></i>
                      <p>
                        Relatórios
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </a>
                    <ul
                      className={`nav nav-treeview ${
                        isRelatoriosOpen ? "show" : ""
                      }`}
                    >
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "AplicGarServ", actions: ['view']}
                        ]}
                        >
                          <Link to={`/aplicacao_garantia`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Garantia de aplicações</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "HistogrServ", actions: ['view']}
                        ]}
                        >
                          <Link
                            to={`/histograma_manutencoes_corretivas`}
                            className="nav-link"
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>Histograma de Manutenções Corretivas</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "HistManServ", actions: ['view']}
                        ]}
                        >
                          <Link to={`/historico_manutencao`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Historico de Manutenção</p>
                          </Link>
                        </Permissions>
                      </li>
                      <li className="nav-item">
                        <Permissions 
                        requiredPermissions={[
                          {entidade: "InvCliSv", actions: ['view']}
                        ]}
                        >
                          <Link to={`/inventario_clientes`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Inventário de Clientes</p>
                          </Link>
                        </Permissions>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
}
